export const USER_GROUP_ENDPOINTS = {
  LIST: (pbxId: number) => `/app/v1/pbxes/${pbxId}/user-groups/`,
  DETAIL: (pbxId: number, id: number) =>
    `/app/v1/pbxes/${pbxId}/user-groups/${id}/`,
  CREATE: (pbxId: number) => `/app/v1/pbxes/${pbxId}/user-groups/`,
  UPDATE: (pbxId: number, id: number) =>
    `/app/v1/pbxes/${pbxId}/user-groups/${id}/`,
  DELETE: (pbxId: number, id: number) =>
    `/app/v1/pbxes/${pbxId}/user-groups/${id}/`,
  PBX_USERS: (pbxId: number) => `/app/v1/pbxes/${pbxId}/users/`,
} as const

export const USER_GROUP_QUERY_KEYS = {
  all: ['userGroups'] as const,
  lists: () => [...USER_GROUP_QUERY_KEYS.all, 'list'] as const,
  list: (params: Record<string, unknown>) =>
    [...USER_GROUP_QUERY_KEYS.lists(), params] as const,
  details: () => [...USER_GROUP_QUERY_KEYS.all, 'detail'] as const,
  detail: (id: number) => [...USER_GROUP_QUERY_KEYS.details(), id] as const,
} as const
